import { render, staticRenderFns } from "./EbaAggregatedResultsTableBody.vue?vue&type=template&id=148e07de&"
import script from "./EbaAggregatedResultsTableBody.vue?vue&type=script&lang=ts&"
export * from "./EbaAggregatedResultsTableBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports